import { Button, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { Modal } from '../../elements/modals/Modal';

interface IHolterClearModalProps {
    clearHolter: () => Promise<void>;
    onClose: () => Promise<void>;
}

export function HolterClearModal(props: IHolterClearModalProps) {
    const translate = getSelectedLanguage();

    return (
        <Modal
            actionButtons={[
                <Button
                    color="primary"
                    key={'cancel'}
                    onClick={props.clearHolter}
                >
                    {translate.common.proceed}
                </Button>,
            ]}
            isOpen
            onClose={props.onClose}
            size="small"
            title={translate.holter.clearEcgRecorder}
        >
            <Text>We maken de recorder voor je leeg, zodat je deze kunt instellen voor een nieuw onderzoek</Text>
        </Modal>
    );
}
